module.exports = __webpack_public_path__ + "static/media/hajid.c3d41bcd.png";